import { useContext } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import AppContext from '../AppContext';
import { CreateOrEditFolderPayload, EditFolderInput } from './generated/types';

const mutation = `mutation EditFolder ($input: EditFolderInput! ) {
        editFolder(input: $input) {
            id
        }
    }`;

export const useEditFolder = () => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (params: {
            orgId: string;
            folderName: string;
            folderId: string;
            parentFolderId?: string;
            editorGroups?: Array<string>;
            readerGroups?: Array<string>;
        }) => {

            const input: EditFolderInput = {
                id: params.folderId,
                name: params.folderName,
                orgId: params.orgId,
                parentFolder: params.parentFolderId,
                editorGroups: params.editorGroups,
                readerGroups: params.readerGroups,
            };

            const response = await (context.api.graphql({
                query: mutation,
                variables: {
                    input,
                },
            }) as Promise<{
                data: {
                    editFolder: CreateOrEditFolderPayload;
                };
            }>);

            return response.data.editFolder.id as string;
        },
        onSuccess: (_, variables) => {
            void queryClient.invalidateQueries({ queryKey: ['listFolders', variables.parentFolderId] });
            void queryClient.invalidateQueries({ queryKey: ['GetFolder', variables.folderId] });
        },
    });
};